import { getReverseLocation } from "@/services/api/coordinates";
import { useQuery } from "@tanstack/react-query";
export const useGetReverseCoordinates = (lat, lng, options) => {
    return useQuery({
        queryKey: ["reverseCoordinates", lat, lng],
        queryFn: () => getReverseLocation(lat, lng),
        enabled: options?.enabled,
        refetchOnWindowFocus: true,
    });
};
